import RemainingCharactersInput from './RemainingCharactersInput';

export default RemainingCharactersInput;
